import { getAuthApiToken } from "./tokenService";
// // src/api/authApi.js
// const [apiUrl, setApiUrl] = useState('http://127.0.0.1:3000'); 
const apiUrl = process.env.REACT_APP_AUTH_URL;
// // Load API URL from environment or localStorage
//   useEffect(() => {
//     const savedUrl = process.env.REACT_APP_API_URL ||
//                   localStorage.getItem('apiUrl') || 
//                      'http://127.0.0.1:3000';
//     setApiUrl(savedUrl);
//   }, []);

export const getMe = async () => {
  const accessToken = await getAuthApiToken();
  const res = await fetch(`${apiUrl}/api/auth/me`, {
    headers: { "Authorization": `Bearer ${accessToken}` }
  });
  return await res.json();
};

export const signup = async (idToken, companyName) => {
  const res = await fetch(`${apiUrl}/api/auth/signup`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${idToken}`
    },
    body: JSON.stringify({ companyName })
  });
  return await res.json();
};
